import { Component, Input, OnInit } from '@angular/core';
import { CartObj } from '../../models/models';

@Component({
  selector: 'app-lab-cart-modal',
  templateUrl: './lab-cart-modal.component.html',
  styleUrls: ['./lab-cart-modal.component.css']
})
export class LabCartModalComponent implements OnInit {

  @Input() selectedCart:CartObj;
  constructor() {
    this.selectedCart = this.resetSelectedCart();
 }

 resetSelectedCart=():CartObj=>{
    const cart:CartObj = {
      cartId:'',
      cartCapacity:'',
      flag:false,
      color:'',
      filterFlag:false,
      dateOfCreation:''
    }
    return cart;
  }

  ngOnInit(): void {
  }
}
